import React from 'react'

const LoggedChatAside = () => {
  return (
    <div>LoggedChatAside</div>
  )
}

export default LoggedChatAside